<mat-dialog-content class="dialogcontent flexcolumn">
  @if (docs && docs.length > 0) {
    Facture # {{ dialogdata.fseOrder.id }}
    @if (docs[0]; as doc ) {
      <fieldset>
        @if (doc.dateheureetatdossier) {
          <legend>Détail ARL du {{ (doc.dateheureetatdossier ) | fseDateTimeToFr }}</legend>
          @if (doc.codeaction) {
            <div class="flexrow">
              <span class="title">Code Action</span>
              <span class="value">{{ doc.codeaction }}</span>
            </div>
          }
          @if (doc.etatdossier) {
            <div class="flexrow">
              <span class="title">État Dossier</span>
              <span class="value">{{ doc.etatdossier }}</span>
            </div>
          }
          @if (doc.diagnostic) {
            <div class="flexrow">
              <span class="title">Diagnostic</span>
              <span class="value">{{ doc.diagnostic }}</span>
            </div>
          }
        } @else {
          <div>
            Pas D'ARL
          </div>
        }
      </fieldset>
    }
    <div class="flexrow button-row">
      <button mat-flat-button color="primary" (click)="openBsDialogFromDossier($event)">Voir les PJs</button>
    </div>
  } @else {
    Facture # {{ dialogdata.fseOrder.id }}
    <fieldset>
      <legend>Pièces justificatives</legend>
      <div>Aucune pièce justificative (SCOR) liée à cette facture.</div>
    </fieldset>
    <div class="flexrow button-row">
      <button mat-flat-button color="primary" (click)="openBsDialogFromDossier($event)">Voir les PJs</button>
    </div>
  }
</mat-dialog-content>
